(function () {
  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component[data-ss-cart-drawer]');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-ss-cart-count]').forEach(function (el) {
      var value = parseInt(count, 10) || 0;
      el.textContent = String(value);
      el.hidden = value <= 0;
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ss-cart-open]');
    if (!trigger) return;
    event.preventDefault();
    openCartDrawer();
  });

  document.addEventListener('cart:update', function (event) {
    var cart = event.detail && event.detail.resource;
    if (cart && typeof cart.item_count === 'number') {
      updateCartCount(cart.item_count);
    }
  });

  window.ssCart = {
    open: openCartDrawer,
    updateCount: updateCartCount,
  };
})();
